<dx-popup
  class="donor_activity"
  *ngIf="data"
  [(visible)]="visible"
  [width]="'1050px'"
  [height]="'1100px'"
  [maxHeight]="'80vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  (onHiding)="handlePopupClose()"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
>
  <div class="popup_div">
    <div class="whole_div">
      <div class="voucher_main">
        <div class="title_div">Gift Voucher</div>
        <div class="title_div">
          <img
            width="276px"
            height="276px"
            style="margin-right: 8px"
            src="./assets/images/icon/gift_icon.svg"
          />
        </div>
        <div class="congratulation_div">
          <div class="cong_text">Congratulations!</div>
          <div *ngIf="data.campaign_title">
            You’ve won a gift for donating to
            <span style="color: #0054a6">“{{ data.campaign_title }}”</span>
            campaign! Thank you for your generous support.
          </div>
          <div *ngIf="data.redeemed_points">
            Your Reword points are Redeemed
          </div>
        </div>
        <div class="voucher-container">
          <div class="voucher-section">
            <div class="voucher-label">Your Gift Voucher Code:</div>
            <div class="voucher-box">
              <span class="voucher-code">{{ data.code }}</span>
              <button
                class="copy-icon"
                title="Copy"
                (click)="copyToClipboard(data?.code)"
              >
                <img
                  width="24px"
                  height="24px"
                  style="margin-right: 8px"
                  src="./assets/images/icon/copy_blue_icon.svg"
                />
              </button>
            </div>
          </div>

          <div class="voucher-section">
            <div class="voucher-label">Valid Until:</div>
            <div class="voucher-box">
              <span class="voucher-date">
                {{ data?.expiry_date | date : "dd MMM yyyy" }}</span
              >
            </div>
          </div>

          <div class="voucher-section">
            <div class="voucher-label">Redeem on:</div>
            <div class="voucher-box">
              <a class="voucher-link" [href]="data?.website" target="_blank">
                {{ data?.website }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</dx-popup>
